import React from "react";
import { cn } from "@/lib/utils";

export function PageHeader({ eyebrow, title, subtitle, actions, className }) {
  return (
    <div
      className={cn("flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8", className)}
      data-testid="page-header"
    >
      <div>
        {eyebrow && (
          <div className="text-[11px] font-semibold uppercase tracking-[0.15em] text-ink-500 mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-heading text-3xl sm:text-4xl leading-tight tracking-tight text-ink-900">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-ink-500 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 md:justify-end">{actions}</div>}
    </div>
  );
}

export function SectionHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-end justify-between mb-4">
      <div>
        <h2 className="font-heading text-xl text-ink-900">{title}</h2>
        {subtitle && <p className="text-sm text-ink-500">{subtitle}</p>}
      </div>
      {actions}
    </div>
  );
}

export default PageHeader;
